export const entityName = 'dataStoreConnections';
export const idAttribute = 'connectionId';
